/* src/app/customer-admin/customer-admin-presenter/customer-admin-presenter.component.scss */
body#themeTag :host ::ng-deep span {
  width: 100%;
}
body#themeTag :host ::ng-deep .p-inputtext.p-component.p-element {
  min-width: 100% !important;
  max-width: 100% !important;
}
body#themeTag :host ::ng-deep .p-dropdown.p-component {
  width: 100% !important;
  text-align: start;
}
body#themeTag :host ::ng-deep .p-dropdown-trigger {
  text-align: center;
}
body#themeTag :host ::ng-deep .p-inline-message.p-component.p-inline-message-info {
  width: 99%;
  text-align: center;
}
body#themeTag :host ::ng-deep .p-inline-message-icon {
  width: 2em;
  text-align: center;
}
body#themeTag :host ::ng-deep .p-float-label-focus label,
body#themeTag :host ::ng-deep .p-float-label .p-dropdown:not(.p-dropdown-clearable) ~ label {
  top: -0.55rem;
  font-size: 12px;
  font-weight: 100;
  color: var(--p-inputtext-color);
  transform: translateY(0);
  background: var(--surface-card);
}
body#themeTag :host ::ng-deep .p-float-label .p-dropdown.p-inputwrapper-filled ~ label {
  top: -0.55rem;
  font-size: 12px;
  color: var(--p-inputtext-color);
  transform: translateY(0);
}
/*# sourceMappingURL=customer-admin-presenter.component.css.map */
